import { 
    VAlert,
    VBtn,
    VIcon
} from 'vuetify/lib'
import VModal from '@/vuetify_custom/v-modal_v1'
import {exportTempt, importCustomerMonthSalaryTotalApi, exportFailFileApi} from '../service'
import styles from './pay.module.less'
const list = ['a、员工出勤情况中的「实际出勤天数」字段值；', 'b、公司补贴中的「餐补」、「异地补贴」字段值；', 'c、其他发放中的「课时发放」、「奖金/提成发放」、「内推奖发放」、「转正津贴」、「其他发放」字段值；', 'd、社保公积金支持导入更新所有单位及个人缴纳的字段值；', 'e、个税信息支持更新「个税专项附加扣除」、「个税」字段值。']
export default {
    data() {
        return {
            dis: false,
            saving: false,
            params: {
                id:null,
                file: null,
                success_row_num: 0,
                fail_row_num: 0,
                all_num:0,
                fail_file: '',
            },
            type: 1
        }
    },
    methods: {
        show(id) {
            this.type = 1
            this.params = {
                id,
                file: null,
                success_row_num: 0,
                fail_row_num: 0,
                all_num:0,
                fail_file: '',
            }
            this.dis = true
        },
        upload() {
            this.el = document.createElement('input')
            this.el.setAttribute('type', 'file')
            this.el.style.display = 'none'
            this.$refs.contain.appendChild(this.el)
            this.el.click()
            this.el.addEventListener('change', this.uploadFile)
        },
        uploadFile() {
            const file = this.el.files[0]
           if (file && ['xlsx', 'csv', 'xls', 'excel', 'spreadsheetml.sheet'].some(item => {
            return file.type.includes(item)
           })) {

            this.params.file = file
            return 
           } 
           this.$Message.error('不支持该格式！')
           
          },

    },
    render() {
            const _this = this
            return <VModal
                        v-model={this.dis}
                        dynamicHeight
                        persistent
                        heightRate={0.9}
                        title="导入数据"
                        width={800}
                        ref="modal"
                        okText="关闭"
                        cancelText=""
                        on={{
                            ok() {
                                _this.dis = false
                            }
                        }}
                    >
                       {this.type === 1 && <div>
                        <VAlert icon={false} outlined type="warning">
                            导入说明：请下载批导模板，在模板的基础上更新数据后上传。
                            <VBtn
                                small
                               outlined
                               color="primary"
                               on={{
                                   click:() => {
                                        exportTempt(this.params.id)
                                   }
                               }}
                            >
                                下载当月薪酬    
                            </VBtn>
                        </VAlert>
                        <div>
                            <div class={styles['upload-contain']}>
                                <div>
                                    <div style="text-align: center;margin-bottom:10px">
                                        <VIcon size="60" color={_this.params.file && 'success' || ''}>mdi-file</VIcon>
                                    </div>
                                   { _this.params.file && <div style="text-align: center;margin-bottom:5px">
                                        {_this.params.file.name}
                                    </div>}
                                    <div style="text-align: center;margin-bottom:10px">
                                        <VBtn
                                              
                                                color="primary"
                                                outlined
                                                on={{
                                                    click() {
                                                        _this.upload()
                                                    }
                                                }}>
                                                上传
                                        </VBtn>
                                    </div>
                                    <div style="text-align: center">
                                        <p>支持扩展名：.xls，.xlsx，.csv</p>
                                    </div>
                                </div>
                            </div>
                       
                            <div style="text-align:center;margin-top:10px">
                                <VBtn loading={_this.saving} depressed color="primary" disabled={!this.params.file} on={{click() {
                                    const { id, file} = _this.params
                                    const params = new FormData()
                                
                                    params.append('id', id)
                                    params.append('file', file)
                                 
                                    _this.saving = true
                                    importCustomerMonthSalaryTotalApi(params).then(res => {
                                        _this.type = 2
                                        _this.params.success_row_num = res.success_row_num
                                        _this.params.fail_row_num = res.fail_row_num
                                        _this.params.all_num = (Number(res.fail_row_num) || 0) + (Number(res.success_row_num) || 0)
                                        _this.params.fail_file = res.fail_file
                                        _this.$emit('success')
                                    }).finally(() => {
                                        _this.saving = false
                                    })
                                }}}>
                                    导入
                                </VBtn>
                            </div>
             
                        </div>
                        <div
                            ref="contain" 
                            style="display:none"
                            />
                        <div>
                            <p class={[styles['p-n'], styles['p-b']]}>帮助说明：</p>
                            <p class={styles['p-n']}>1、请勿独自修改表格列，表格标记为橙色的字段可以进行导入修改字段值。</p>
                            <p class={styles['p-n']}>2、更新字段数据后，“税前工资”及“税后工资”将由系统自动计算得出。</p>
                        </div>
                        </div>}
                        {this.type === 2 && <div>
                            <div class={styles['upload-contain']}>
                                <div style="text-align: center;">
                                    <div>
                                        <VIcon size="60" color="success">mdi-checkbox-marked-circle</VIcon>
                                    </div>
                                    <div>
                                        <h3>导入成功</h3>
                                    </div>
                                    <div >
                                        <span>文件解析共{_this.params.all_num}行，</span>
                                        <span style="color:#4caf50">成功导入{_this.params.success_row_num}行，</span>
                                        <span style="color:red">失败{_this.params.fail_row_num}行，</span>
                                       {!!_this.params.fail_file && <span>点击下载<span style="cursor:pointer;color:#1867c0;text-align: center;" on={{click() {
                                            exportFailFileApi(_this.params.fail_file)
                                        }}}>失败文件</span></span>}
                                    </div>
                                </div>
                            </div>
                        </div>}
                    </VModal>
    }
}